import React, { useEffect, useState } from "react";
import { Loader2, ScrollText, ShieldCheck } from "lucide-react";
import api from "@/lib/api";
import Markdown from "@/components/Markdown";

// Shared page for Terms & Conditions and Privacy Policy. `which` = "terms" | "privacy".
export default function Legal({ which = "terms" }) {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/legal").then((r) => { setContent(r.data[which] || ""); setLoading(false); }).catch(() => setLoading(false));
  }, [which]);

  const Icon = which === "privacy" ? ShieldCheck : ScrollText;
  return (
    <div className="px-4 sm:px-6 lg:px-12 py-10 max-w-3xl" data-testid={`legal-${which}`}>
      <div className="flex items-center gap-3 mb-6">
        <Icon className="w-6 h-6 text-[#E6B34A]" />
        <h1 className="font-display font-black text-3xl lg:text-4xl tracking-tighter">
          {which === "privacy" ? "Privacy Policy" : "Terms & Conditions"}
        </h1>
      </div>
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-[#E6B34A]" /></div>
      ) : (
        <div className="rounded-2xl border border-white/5 bg-[#141C42] p-6 sm:p-8">
          <Markdown text={content} />
        </div>
      )}
    </div>
  );
}
